<template>
  <div class="error-wrapper">
    <div class="error">
      <div class="top-area">
        <p class="txt">강원특별자치도교육청교육과학정보원</p>
      </div>
      <div class="bottom-area">
        <div class="tit-area">
          <img src="@/assets/images/portal/icon/notfound/icon_sad.svg" alt="" class="icon img"/>
          <h3 class="tit"><strong>페이지</strong>를 찾을 수 없습니다</h3>
        </div>
        <div class="txt-area">
          <p>
            방문하시려는 페이지의 주소가 잘못 입력되었거나,<br/>
            페이지의 주소가 변경 혹은 삭제되어 요청하신 페이지를 찾을 수
            <br class="web-visible"/>
            없습니다. 입력하신 주소가 정확한지 다시 한번 확인해 주시기 바랍니다
          </p>
        </div>
        <div class="btn-area">
          <el-button type="primary" class="size-xlg is-round">
            <nuxt-link to="/">돌아가기</nuxt-link>
          </el-button>
        </div>
        <div class="logo-area">
          <img src="@/assets/images/common/logo/logo.png" alt="강원특별자치도교육청교육과학정보원"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  components: {},
  created() {
  },
  computed: {},
  mounted() {
  },
};
</script>

<style></style>
